import _ from 'lodash';
import ah from '../utils/ajax-helper';
export var getAuditLogTotalStatistics = function getAuditLogTotalStatistics(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/audit-log-statistics/total"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // search data source logs

export var getAuditLogStatistics = function getAuditLogStatistics(contextRoot, noProgress, dateTime, sort) {
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 10;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var parameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      start: dateTime.from,
      end: dateTime.to
    };
    ah.get("".concat(contextRoot, "/audit-log-statistics/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};